export const DEFAULT_NAME = 'Untitled project'
export const SELECT_ALL_NEW_TEXT_KEY = 'SELECT_ALL_NEW_TEXT_KEY'
